import React from 'react'
import { Container, Row, Col } from 'reactstrap';

export default class AboutUs extends React.Component{
    render(){
        return (
            <div className="padding-vert">
        <Container>
          <Row>
            <Col>
              <div className="footer text-left">
                <h5>Saichha Cable Network Office</h5>
                <p>Shop no: 3</p>
                <p>Hotel Saisurya Complex</p>
                <p>Kankuri road, Shirdi - 423409</p>
                <p>Tal: Rahata Dist: Ahmednagar</p>
                <br />
                <p>
                  <a href="tel:02423257636">
                    <i className="fas fa-phone-volume" /> 02423-257636
                  </a>
                  <a href="tel:9975819443">
                    <i className="fab fa-whatsapp" /> 9975819443
                  </a>
                  <a href="tel:9850942220">
                    <i className="fas fa-headset" /> Support: 9850942220
                  </a>
                </p>

                <br />
                <br />
                <div className="text-right">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://goo.gl/maps/ZQ6TfrLT8TufWhnc7"
                  className="mybtn"
                >
                  <i className="fa fa-map-marked-alt" />
                  &nbsp; Get Directions
                </a>
                </div>
              </div>
            </Col>

            <Col sm={12} md={6}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d21241.683173501897!2d74.47237318749211!3d19.75368648414332!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bdc5b95942e3f71%3A0x4af8c571e224b5dd!2sSaichha+Cable+Network+%26+Broadband!5e0!3m2!1sen!2sin!4v1545913640758"
                title="map"
                width="100%"
                height="100%"
                style={{ border: 0 }}
              />
            </Col>
          </Row>
        </Container>
        <br/>
        <br/>
        <br/>
        <br/>
      </div>
        )
    }
}